module.exports = __webpack_public_path__ + "img/slider1.jpg?705c18ebfdfd8f29e544871a43cd8a0f";